import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Theme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { useCreateGroupList } from '../../../../sic-lib/api/hooks/useGroupsList';
import { ContactListFilterItem } from '../../../../sic-lib/types/ContactListFilterItem';
import { buildCreateList, ListType } from '../../../../sic-lib/types/Lists';
import { IErrorFormValidation } from '../../../../sic-lib/utils/formValidationHelpers';
import ButtonLoading from '../../../Shared/ButtonLoading';

const useStyles = makeStyles()((theme: Theme) => ({
    paper: {
        width: '100%',
    },
    text: {
        marginBottom: theme.spacing(3),
    },
}));

interface Props {
    isOpen: boolean;
    /* 
        TIP: filters must be directly from the editor in cases where user clicks save before 
        applying filters to redux 
     */
    filters: ContactListFilterItem[];
    onCloseHandler: () => void;
}

export default function DialogCreateFilteredGroup({ isOpen, filters, onCloseHandler }: Props) {
    const { classes } = useStyles();

    // Needs to be deleted once reactQuery is fully implemented for Group List
    //const { requestStatus, asyncCreateList } = useAsyncCreateList();

    const { mutate, isLoading } = useCreateGroupList();

    const [listName, setListName] = React.useState<string>('');

    const handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        setListName(event.target.value);
    };

    const [formError, setFormError] = React.useState<IErrorFormValidation | null>(null);

    const handleSubmit = async () => {
        try {
            const list = buildCreateList({
                name: listName,
                type: ListType.dynamic,
                filters: filters,
            });

            mutate(list);

            onCloseHandler();
        } catch (error: any) {
            if (error.isFormError) {
                setFormError(error as IErrorFormValidation);
            }
        }
    };

    return (
        <Dialog
            maxWidth="xs"
            aria-labelledby="dialog_create_filtered_group"
            open={isOpen}
            PaperProps={{
                className: classes.paper,
            }}
        >
            <DialogTitle id="dialog_create_filtered_group">Create Contacts Group</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body1" className={classes.text}>
                    Enter a title for the new filter group
                </Typography>
                <TextField
                    id="filter_group_title"
                    label="Name"
                    name="name"
                    value={listName}
                    onChange={handleChange}
                    autoFocus
                    fullWidth
                    required
                    error={Boolean(formError)}
                    helperText={formError?.message || ''}
                ></TextField>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCloseHandler}>Cancel</Button>
                <ButtonLoading
                    isLoading={isLoading}
                    onClick={handleSubmit}
                    color="secondary"
                    variant="outlined"
                >
                    Save
                </ButtonLoading>
            </DialogActions>
        </Dialog>
    );
}
